import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import "../styles/Feedback.css";
import steps from "../script/feedbackSteps.js";
import axiosClient from "../api/axiosClient";
import { FiArrowLeft } from "react-icons/fi";

export default function TargetFeedback() {
    const userId = localStorage.getItem("userId"); // ✅ GLOBAL DEFINE
  const navigate = useNavigate();
  const [step, setStep] = useState(0);
  const [form, setForm] = useState({});
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef();

  const current = steps[step];

  useEffect(() => {
    const close = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("click", close);
    return () => document.removeEventListener("click", close);
  }, []);

  const handleSelect = (value) => {
    setForm({ ...form, [current.key]: value });
    setOpen(false);
  };

  // -----------------------------------------------------------------

  const isCurrentStepValid = () => {
    const value = form[current.key];

    if (!value) return false;

    if (value === "Other" && !form[current.key + "Other"]) {
      return false;
    }

    return true;
  };

  const isFormComplete = () => {
    return steps.every((stepItem) => {
      const value = form[stepItem.key];

      if (!value) return false;

      if (value === "Other" && !form[stepItem.key + "Other"]) {
        return false;
      }

      return true;
    });
  };

  // -------------------------------------------------------------------
 const [loading, setLoading] = useState(false);

const handleSubmit = async () => {
  
  if (loading) return; // ✅ double click block

  try {
    setLoading(true);
const token = localStorage.getItem("token");
 const payload = {
      targetCompany: form.companyOther || form.company,
      targetRole: form.roleOther || form.role,
      preparationDeadlineMonths:
        Number(form.codingTimeOther || form.codingTime) * 12 || 0,
      priorCodingExperience: form.experienceOther || form.experience,
      dailyCodingHours: 4,
      nonTechBackground:
        (form.backgroundOther || form.background) === "Non-IT",
      currentEducation: form.educationOther || form.education,
      preferredLanguage: form.languageOther || form.language,
    };

    // ✅ already filled → skip API
    if (localStorage.getItem(`feedback_done_${userId}`) === "true") {
      navigate("/front");
      return;
    }

   const res =    await axiosClient.post("/auth/saveCareerProfile", payload,
        {
          headers:
{
  Authorization:`Bearer ${token}`
}
        }
      );
/*
    // ✅ already filled → skip API
    if (localStorage.getItem(`feedback_done_${userId}`) === "true") {
      navigate("/front");
      return;
    }
*/

   // const res = await axiosClient.post("/auth/saveCareerProfile", payload);

    if (res?.status === 200 || res?.status === 201) {
      localStorage.setItem(`feedback_done_${userId}`, "true");

      await Swal.fire({
        title: "Profile Saved Successfully 🎉",
        text: "Redirecting to dashboard...",
        icon: "success",
        confirmButtonColor: "#7c3aed",
      });

      navigate("/front"); // ✅ ONLY ONE NAV
    }

  } catch (error) {
    console.log("ERROR 👉", error.response || error.message);

    // ✅ backend says already exists
    if (error.response?.status === 409) {
      localStorage.setItem(`feedback_done_${userId}`, "true");
      navigate("/front");
      return;
    }

    Swal.fire({
      title: "Error ❌",
      text: error.response?.data?.message || "Failed to save profile",
      icon: "error",
    });

  } finally {
    setLoading(false);
  }
};

  return (
    <div className="tf-wrapper">
      <div className="tf-card">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center", // ✅ vertical center
            marginBottom: "20px",
          }}
        >
          {/* ⬅ BACK BUTTON */}
          <button
            onClick={() => {
              Swal.fire({
                title: "Go back?",
                text: "Your progress will be lost!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#7c3aed",
                confirmButtonText: "Yes, go back",
              }).then((result) => {
                if (result.isConfirmed) {
                  navigate("/");
                }
              });
            }}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "6px",

              height: "36px",        // ✅ SAME HEIGHT
              padding: "0 16px",     // vertical remove for equal line
              borderRadius: "999px",
              border: "none",
              cursor: "pointer",

              fontWeight: "600",
              fontSize: "13px",
              color: "#fff",

              background: "linear-gradient(135deg, #7c3aed, #a855f7)",
              boxShadow: "0 4px 14px rgba(124,58,237,0.4)",

              transition: "all 0.25s ease",
            }}
          >
            <FiArrowLeft size={14} /> Back
          </button>

          {/* 👉 STEP BADGE */}
          <div
            style={{
              height: "36px",             // ✅ SAME HEIGHT
              display: "flex",
              alignItems: "center",
              padding: "0 16px",
              borderRadius: "999px",

              background: "linear-gradient(135deg, #7c3aed, #a855f7)",
              color: "#fff",
              fontWeight: "600",
              fontSize: "13px",

              boxShadow: "0 4px 14px rgba(124,58,237,0.4)",
            }}
          >
            Step {step + 1} / {steps.length}
          </div>
        </div>

        {/* <div className="tf-step">
          Step {step + 1} / {steps.length}
        </div> */}


        <h2 className="tf-title">{current.label}</h2>

        {/*---------------CUSTOM DROPDOWN------------------ */}
        <div className="tf-select" ref={dropdownRef}>
          <div className="tf-select-box" onClick={() => setOpen(!open)}>
            {form[current.key] || "Select an option"}
            <span className={`tf-arrow ${open ? "open" : ""}`}>⌄</span>
          </div>

          {open && (
            <div className="tf-dropdown">
              {current.options.map((opt, i) => (
                <div
                  key={i}
                  className="tf-option"
                  onClick={() => handleSelect(opt)}
                >
                  {opt}
                </div>
              ))}
            </div>
          )}
        </div>

        {form[current.key] === "Other" && (
          <input
            className="tf-input"
            type="text"
            placeholder="Type your answer..."
            value={form[current.key + "Other"] || ""}
            onChange={(e) =>
              setForm({
                ...form,
                [current.key + "Other"]: e.target.value,
              })
            }
          />
        )}

        {/*----------------- BUTTONS----------------------- */}
        <div className="tf-buttons">
          <button
            className="tf-btn tf-prev"
            disabled={step === 0}
            onClick={() => setStep(step - 1)}
          >
            Prev
          </button>

          {step < steps.length - 1 ? (
            <>


              <button
                className="tf-btn tf-next"
                onClick={() => {
                  if (!isCurrentStepValid()) {
                    Swal.fire({
                      icon: "warning",
                      title: "Incomplete ❗",
                      text: "Please select or fill this option before proceeding.",
                      confirmButtonColor: "#7c3aed",
                    });
                    return;
                  }

                  setStep(step + 1);
                }}
              >
                Next
              </button>
            </>
          ) : (
            <button
              className="tf-btn tf-next"
              disabled={!isFormComplete()}
              onClick={() => {
                if (!isFormComplete()) {
                  Swal.fire({
                    icon: "warning",
                    title: "Incomplete Form ❗",
                    text: "Please fill all the fields before submitting.",
                    confirmButtonColor: "#7c3aed",
                  });
                  return;
                }

                handleSubmit();
              }}
            >
              Submit
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
